import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function DeactivateAccount() {
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();
  
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [selectedPeriod, setSelectedPeriod] = useState(null);


  const {
    data: deactivationPeriods,
    isLoading: isLoadingPeriods,
    isError: isErrorPeriods
  } = useQuery({
    queryKey: ['deactivationPeriods'],
    queryFn: async () => {
      const res = await axios.get(`${API_URL}/deactivate-account-period-api`, {
        withCredentials: true
      });
      return res.data;
    },
    staleTime: 0,
    cacheTime: Infinity
  });

  const [selectedReason, setSelectedReason] = useState(null);
const [reasonSuggestion, setReasonSuggestion] = useState('');
const [password, setPassword] = useState('');

  const handleCheckboxChange = (e) => {
    setSelectedReason(e.target.value); // for simplicity, allow only one reason
  };
  
  const handleDeactivateAccount = async () => {
    if (!selectedPeriod) {
      toast.error("Select Period!");
      return;
    }
  
    try {
      const res = await axios.post(`${API_URL}/deactivate-my-account-api`, {
        period: selectedPeriod
      }, {
        withCredentials: true
      });
  
      toast.success("Account deactivated successfully.");
      setTimeout(() => {
        navigate('/login');  
      }, 1500);
    } catch (err) {
      toast.error(err.response?.data?.error || "Something went wrong.");
    }
  };
  

  return (
    <div className='scrollPageContainer theme-light'>
      <div className='main-wrapper'>

        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />
        <ToastContainer />


         <div className='page-wrapper'>

         <div className='content container-fluid'>

                        
                        <div className='card-header-custom'>
                          <div className='header-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                          </div>
                          <h1>Deactivate Your Account</h1>
                          <p>We're sorry to see you go. Please review the information below.</p>
                        </div>
        
                        <div className='card-body-custom'>
                          
                          <div className='info-alert'>
                            <div className='info-alert-title'>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              What happens when you deactivate?
                            </div>
                            <ul className='restrictions-list'>
                              <li>You will not receive any messages from other users</li>
                              <li>All notifications and updates will be disabled</li>
                              <li>Your profile will be hidden from all users</li>
                            </ul>
                          </div>
        
                          <div className='section-title'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Choose Deactivation Duration
                          </div>
        
                          {isLoadingPeriods ? (
                            <div className='loading-state'>
                              <div className='spinner-custom'></div>
                              <div className='loading-text'>Loading options...</div>
                            </div>
                          ) : isErrorPeriods ? (
                            <div className='alert alert-danger' role='alert'>
                              <strong>Error!</strong> Unable to load deactivation periods. Please refresh the page.
                            </div>
                          ) : (
                            <div className='period-grid'>
                              {deactivationPeriods.map((period) => (
                                <div className='period-card' key={period.id}>
                                  <input
                                    type='checkbox'
                                    id={`period_${period.id}`}
                                    value={period.period}
                                    checked={selectedPeriod === period.period}
                                    onChange={() => setSelectedPeriod(period.period)}
                                  />
                                  <label className='period-card-label' htmlFor={`period_${period.id}`}>
                                    <span>{period.period}</span>
                                    <div className='checkmark'>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                      </svg>
                                    </div>
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
        
                          <div className='action-section'>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            <Link 
              to='/profile-settings'
              style={{ 
                flex: '1',
                padding: '12px',
                fontSize: '17px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '1.5px',
                borderRadius: '10px',
                border: '2px solid #75B437',
                background: 'white',
                color: '#75B437',
                textDecoration: 'none',
                textAlign: 'center',
                transition: 'all 0.3s ease'
              }}
            >
              Cancel
            </Link>
            <button
              className='btn-deactivate'
              onClick={handleDeactivateAccount}
              disabled={!selectedPeriod}
              style={{ flex: '1', width: 'auto' }}
            >
              Deactivate
            </button>
          </div>
        </div>
        
                        </div>
                    
                    
                  
                </div>
 </div>
        


        <style>{`
   /* Replace your existing styles with these ultra-compact ones */

.deactivate-wrapper {
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  min-height: 100vh;
  padding: 10px 12px; /* Further reduced */
  display: flex;
  align-items: center;
  justify-content: center;
}

.deactivate-container {
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

.deactivate-card {
  background: white;
  border-radius: 16px; /* Reduced from 20px */
  box-shadow: 0 25px 70px rgba(24, 74, 44, 0.25);
  overflow: hidden;
  animation: fadeInScale 0.6s ease-out;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.card-header-custom {
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  padding: 18px 25px; /* Further reduced */
  text-align: center;
  position: relative;
  overflow: hidden;
}

.card-header-custom::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.header-icon {
  width: 50px; /* Further reduced */
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px; /* Further reduced */
  backdrop-filter: blur(10px);
}

.header-icon svg {
  width: 28px; /* Further reduced */
  height: 28px;
  color: white;
}

.card-header-custom h1 {
  color: white;
  font-size: 22px; /* Further reduced */
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.5px;
  position: relative;
  z-index: 1;
}

.card-header-custom p {
  color: rgba(255, 255, 255, 0.9);
  margin: 6px 0 0; /* Further reduced */
  font-size: 13px; /* Further reduced */
  position: relative;
  z-index: 1;
}

.card-body-custom {
  padding: 18px 22px; /* Further reduced */
}

.info-alert {
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  border-left: 4px solid #ffa726; /* Reduced from 5px */
  border-radius: 8px; /* Reduced from 10px */
  padding: 12px 15px; /* Further reduced */
  margin-bottom: 15px; /* Further reduced */
  box-shadow: 0 4px 15px rgba(255, 167, 38, 0.15);
}

.info-alert-title {
  color: #e65100;
  font-size: 14px; /* Further reduced */
  font-weight: 700;
  margin-bottom: 8px; /* Further reduced */
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-alert-title svg {
  width: 18px; /* Further reduced */
  height: 18px;
}

.restrictions-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.restrictions-list li {
  color: #e65100;
  padding: 6px 0; /* Further reduced */
  padding-left: 26px; /* Further reduced */
  position: relative;
  font-size: 12px; /* Further reduced */
  font-weight: 500;
}

.restrictions-list li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  width: 16px; /* Further reduced */
  height: 16px;
  border-radius: 50%;
}

.restrictions-list li:after {
  content: "✕";
  position: absolute;
  left: 4px;
  top: 6px;
  color: red;
  font-weight: bold;
  font-size: 11px; /* Further reduced */
}

.section-title {
  color: #184A2C;
  font-size: 15px; /* Further reduced */
  font-weight: 700;
  margin-bottom: 12px; /* Further reduced */
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-title svg {
  width: 18px; /* Further reduced */
  height: 18px;
  color: #75B437;
}

.period-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); /* Further reduced */
  gap: 10px; /* Further reduced */
  margin-bottom: 15px; /* Further reduced */
}

.period-card {
  position: relative;
}

.period-card input[type="checkbox"] {
  display: none;
}

.period-card-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 8px; /* Further reduced */
  border: 0px solid #e0e0e0;
  border-radius: 10px; /* Further reduced */
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fafafa;
  min-height: 42px; /* Further reduced */
  position: relative;
  overflow: hidden;
}

.period-card-label::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #75B437 0%, #184A2C 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.period-card-label span {
  position: relative;
  z-index: 1;
  font-weight: 600;
  font-size: 13px; /* Further reduced */
  color: #333;
  transition: color 0.3s ease;
}

.period-card-label:hover {
  border-color: #75B437;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(117, 180, 55, 0.25);
}

.period-card input[type="checkbox"]:checked + .period-card-label {
  border-color: #184A2C;
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(24, 74, 44, 0.35);
}

.period-card input[type="checkbox"]:checked + .period-card-label::before {
  opacity: 1;
}

.period-card input[type="checkbox"]:checked + .period-card-label span {
  color: white;
}

.checkmark {
  position: absolute;
  top: 5px; /* Further reduced */
  right: 5px;
  width: 18px; /* Further reduced */
  height: 18px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;
  z-index: 2;
}

.period-card input[type="checkbox"]:checked + .period-card-label .checkmark {
  opacity: 1;
  transform: scale(1);
}

.checkmark svg {
  width: 11px; /* Further reduced */
  height: 11px;
  color: #184A2C;
}

.action-section {
  margin-top: 15px; /* Further reduced */
  padding-top: 15px; /* Further reduced */
  margin-bottom: 0;
  border-top: 2px solid #f0f0f0;
}

.btn-deactivate {
  padding: 9px; /* Further reduced */
  font-size: 14px; /* Further reduced */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px; /* Further reduced */
  border-radius: 8px; /* Reduced from 10px */
  border: none;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(220, 53, 69, 0.35);
  position: relative;
  overflow: hidden;
}

.btn-deactivate::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn-deactivate:hover::before {
  width: 300px;
  height: 300px;
}

.btn-deactivate:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.45);
}

.btn-deactivate:active {
  transform: translateY(-1px);
}

.btn-deactivate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.2);
}

.btn-deactivate:disabled:hover {
  transform: none;
}

/* Cancel button matching size */
.action-section a {
  padding: 9px !important; /* Match button size */
  font-size: 14px !important;
  letter-spacing: 1px !important;
  border-radius: 8px !important;
}

.loading-state {
  text-align: center;
  padding: 20px 15px; /* Further reduced */
}

.spinner-custom {
  width: 35px; /* Further reduced */
  height: 35px;
  border: 3px solid #f3f3f3; /* Further reduced */
  border-top: 3px solid #75B437;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px; /* Further reduced */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #666;
  font-size: 13px; /* Further reduced */
  font-weight: 500;
}

/* Mobile - ultra compact */
@media (max-width: 768px) {
  .deactivate-wrapper {
    background: #EBF4ED;
    background-attachment: fixed;
    min-height: 100vh;
    padding: 8px 8px;
    display: flex;
    align-items: center;
  }

  .card-header-custom {
    padding: 15px 18px;
  }

  .card-header-custom h1 {
    font-size: 20px;
  }

  .card-header-custom p {
    font-size: 12px;
  }

  .header-icon {
    width: 45px;
    height: 45px;
    margin-bottom: 8px;
  }

  .header-icon svg {
    width: 26px;
    height: 26px;
  }

  .card-body-custom {
    padding: 15px 12px;
  }

  .info-alert {
    padding: 10px 12px;
    margin-bottom: 12px;
  }

  .info-alert-title {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .restrictions-list li {
    padding: 5px 0;
    font-size: 11px;
    padding-left: 22px;
  }

  .period-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-bottom: 12px;
  }

  .period-card-label {
    padding: 8px 6px;
    min-height: 38px;
  }

  .period-card-label span {
    font-size: 12px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .action-section {
    margin-top: 12px;
    padding-top: 12px;
  }

  .btn-deactivate,
  .action-section a {
    padding: 8px !important;
    font-size: 12px !important;
    letter-spacing: 0.8px !important;
  }
}
      `}</style>


      </div>
    </div>
  );
}

export default DeactivateAccount;
